/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

// index page sections


import {sendRegistrationEmail} from "../../components/helpers/UserHelpers";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";

class RegistrationComplete extends React.Component {
  state = {
    songBookCount: null
  };

  registrationEmailSent = false;

  constructor(props) {
    super(props);

    sessionStorage.removeItem("clientSecret");
  }

  componentDidMount() {
    const registrationData = sessionStorage.getItem("customer-registration");
    if (!this.registrationEmailSent && registrationData) {
      this.registrationEmailSent = true; // Mark that the email sending has been initiated
      const userId = JSON.parse(registrationData).id;
      sendRegistrationEmail(userId).then(result => {
        if (result) {
          sessionStorage.removeItem("customer-registration");
        }
      });
    }

    if (typeof window.gtag === 'function') {
      const storedPlan = sessionStorage.getItem("selectedPlan");
      if (!["month", "year"].includes(storedPlan)) return;

      const plan = storedPlan === "month" ? "monthly" : "annual";
      const value = storedPlan === "month" ? 6.50 : storedPlan === "year" ? 60.00 : 0;

      window.gtag('event', 'register_complete', {
        plan: plan
      });

      window.gtag('event', 'purchase', {
        value: value,
        currency: 'GBP',
        plan: plan
      });
    }
  }

  render() {
    return (
      <>
        <SeoNoIndex noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Welcome to The Worship Bible{" "}
                        <span>registration confirmed</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="8">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-success rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-istanbul" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                Registration successful
                              </h2>
                            </Col>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase text-right">
                              </h2>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            Welcome to The Worship Bible, please sign in to start using the benefits of being a member.
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-warning rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-planet" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                Sign In
                              </h2>
                            </Col>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase text-right">
                              </h2>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            To start using The Worship Bible please sign in.
                          </p>
                          <Button
                              className="mt-4"
                              color="primary"
                              href="/sign-in"
                          >
                            Sign In
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default RegistrationComplete;
